var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 982,
    viewBox: "0 0 464 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M462.649 999.451C387.605 919.339 376.276 902.59 332.465 824.997C321.729 805.987 305.725 769.706 291.738 725.698C287.545 712.527 283.887 699.536 280.652 686.778C257.615 595.496 266.114 497.999 287.534 403.52C342.198 162.46 240.729 -76.0532 49.7156 -168.006C-141.627 -260.11 -378.71 -185.233 -510.15 -35.2608C-527.251 -15.7464 -603.605 76.9423 -628.254 186.848C-706.174 533.846 -385.608 721.35 117.048 899.421C126.828 902.877 173.657 917.388 183.63 920.207L462.679 999.49L462.649 999.451Z",
    stroke: "black",
    strokeOpacity: 0.49,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape6);
export default __webpack_public_path__ + "static/media/shape6.5d8c0101bc15f656d787a56a9e0a2419.svg";
export { ForwardRef as ReactComponent };